import { Accordion as BaseAccordion, type AccordionProps } from "@clipboard-health/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function Accordion(props: Omit<AccordionProps, "LinkComponent">) {
  return <BaseAccordion {...props} LinkComponent={ButtonInternalLink} />;
}
